import AppStoreContext from 'contexts/AppStoreContext';
import React, { useContext } from 'react';
import { Scale } from 'records/MappedSheetVersion';
import {
  CalibrationMachineEventsEnum,
  useCalibrationMachine,
} from '../CalibrationMachine';
import SheetScalerForm from './SheetScalerForm';
import SheetScalerMap from './SheetScalerMap';

const SheetScaler: React.FC = () => {
  const { actions } = useContext(AppStoreContext);

  const { calibrationMachineService, calibrationMachineState } =
    useCalibrationMachine();

  const { sheetVersion } = calibrationMachineState.context;

  const cancel = () => {
    actions.clearAllModals();
  };

  const saveLayerScaleUnitsToStorage = (scale: Scale) => {
    localStorage.setItem('lastModifiedLayerScale', JSON.stringify(scale));
  };

  const saveCalibration = (scale: Scale) => {
    saveLayerScaleUnitsToStorage(scale);
    calibrationMachineService.send({
      type: CalibrationMachineEventsEnum.SAVE_SCALE,
      data: { scale },
    });
  };

  const onBack = () => {
    calibrationMachineService.send(
      CalibrationMachineEventsEnum.BACK_TO_DRAWING_SELECT
    );
  };

  return (
    <div className="column items-start h100">
      <SheetScalerForm
        onBack={onBack}
        onCancel={cancel}
        onSubmit={saveCalibration}
      />
      <SheetScalerMap sheetVersion={sheetVersion} />
    </div>
  );
};

export default SheetScaler;
